import { HashIndexRedirect, RouteElement } from '@components'

import React, { ReactElement, useRef } from 'react'
import { Route, Routes } from 'react-router'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'
import { InboxContent } from '@modules-deprecated/inbox'

import { withRouteLinkClickedListener } from '../../hocs/withRouteLinkClickedListener'
import { useAutomaticPageTitle } from '../../hooks/useAutomaticPageTitle'
import { useGetQueryFromEmberRoute } from '../../hooks/useGetQueryFromEmberRoute'
import { defaultQuery } from './constants/defaultQuery'
import { UmbrellaRoute } from './enums/UmbrellaRoute'
import { UmbrellaInvoices } from './routes/umbrellaInvoices'
import { UmbrellaOrganizations } from './routes/umbrellaOrganizations'
import { UmbrellaProfile } from './routes/umbrellaProfile'
import { UmbrellaRoles } from './routes/umbrellaRoles'
import { UmbrellaSettings } from './routes/umbrellaSettings'
import { UmbrellaSubscriptions } from './routes/umbrellaSubscriptions'
import { UmbrellaUsers } from './routes/umbrellaUsers'

export const Umbrella = withRouteLinkClickedListener((): ReactElement => {
  const emberQuery = useGetQueryFromEmberRoute({ queryParamsValidKeys: Object.keys(defaultQuery) })
  const modulePathname = useRef(window.location.pathname).current
  const { umbrella } = useUmbrella()
  const umbrellaId = umbrella?.id

  useAutomaticPageTitle()

  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteElement isHashRouter>
            <HashIndexRedirect
              modulePathname={modulePathname}
              to={typeof emberQuery?.initialRoute === 'string' ? emberQuery.initialRoute : UmbrellaRoute.Organizations}
            />
          </RouteElement>
        }
      />
      <Route
        path={UmbrellaRoute.Organizations}
        element={
          <RouteElement isHashRouter>
            <UmbrellaOrganizations />
          </RouteElement>
        }
      />
      <Route
        path={UmbrellaRoute.Profile}
        element={
          <RouteElement isHashRouter>
            <UmbrellaProfile />
          </RouteElement>
        }
      />
      <Route
        path={UmbrellaRoute.Roles}
        element={
          <RouteElement isHashRouter>
            <UmbrellaRoles />
          </RouteElement>
        }
      />
      <Route
        path={UmbrellaRoute.Subscriptions}
        element={
          <RouteElement isHashRouter>
            <UmbrellaSubscriptions />
          </RouteElement>
        }
      />
      <Route
        path={UmbrellaRoute.Invoices}
        element={<RouteElement isHashRouter>{umbrellaId && <UmbrellaInvoices umbrellaId={umbrellaId} />}</RouteElement>}
      />
      <Route
        path={UmbrellaRoute.Users}
        element={
          <RouteElement isHashRouter>
            <UmbrellaUsers />
          </RouteElement>
        }
      />
      <Route
        path={`${UmbrellaRoute.Settings}/*`}
        element={
          <RouteElement isHashRouter>
            <UmbrellaSettings />
          </RouteElement>
        }
      />
      <Route
        path={`${UmbrellaRoute.VoucherInbox}/*`}
        element={
          <RouteElement isHashRouter>
            <InboxContent basePath={UmbrellaRoute.VoucherInbox} umbrellaId={umbrellaId} userOrganizationId="" />
          </RouteElement>
        }
      />
    </Routes>
  )
})
